import { transChannel, transRegion } from '@/pages/opinion/utils';

// 饼图折线图数据修改
export const handlePieData = (data: any, way: 'language' | 'channel') => {
  let pieMentionTotal = 0; // 计算饼状图总声量
  let legendData: string[] = []; // 从饼状图上造一个折线图例数组
  let originLegend: string[] = [];
  let pieLegendData: string[] = []; // 饼状图图例数据
  let hasOthers: boolean = false; // 是否有others
  const dataMap = (data: any[], isPie: boolean) => {
    data.map((item) => {
      if (isPie) {
        pieMentionTotal += item?.count;
        item?.name !== 'others'
          ? legendData.push(
              way === 'channel'
                ? transChannel(item?.name)
                : transRegion(item?.name, 3),
            )
          : (hasOthers = true);
        pieLegendData.push(
          way === 'channel'
            ? transChannel(item?.name)
            : transRegion(item?.name, 3),
        );
        originLegend.push(item?.name);
      }
      if (item.name === 'youtube_keyword' || item.name === 'google_keyword')
        item.name = transChannel(item.name);
      item.value = item?.count;
      return item;
    });
  };
  if (data) {
    if (data.mentions) {
      dataMap(data.mentions, true);
    }
    if (data.timeline_of_mentions) {
      dataMap(data.timeline_of_mentions, false);
    }

    hasOthers && legendData.push('others');
    data.pieMentionTotal = pieMentionTotal;
    data.legendData = legendData;
    data.pieLegendData = pieLegendData;
    // originLegend originMentions 用于跳转下钻页（源数据）
    data.defaultLegend = originLegend;
    data.defaultMentions = JSON.parse(JSON.stringify(data.mentions));

    return data;
  }
};
